import React from 'react';

export default class Strategies extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">Basic Self Directed Strategies</h1>
      <p>The page you have requested is currently under construction as we gather the best and latest information.</p>
      <p>Please check back soon for updates.</p>
      <ul>
        <li>Writing a Collaborative Care Plan</li>
        <li>Good Mood Hygiene</li>
        <li>Sleep</li>
        <li>Diet </li>
        <li>Activity</li>
        <li>Stabilize Circadian Rhythms</li>
        <li>Self directed CBT</li>
        <li>Meditation and Mindfullness</li>
      </ul>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Strategies.js